module.exports = __webpack_public_path__ + "static/Gilroy-Regular-11c5b3569c89aeb846430453ceb7f6e6.woff2";